import { Link } from "@tanstack/react-router"
import type { ReactNode } from "react"
import { Logo } from "@/components/Logo"

interface AuthLayoutProps {
  tagline: ReactNode
  subtagline: string
  children: ReactNode
}

export function AuthLayout({ tagline, subtagline, children }: AuthLayoutProps) {
  return (
    <div className="flex min-h-svh w-full">
      {/* Left: image panel */}
      <div className="hidden lg:block lg:w-[45%] relative overflow-hidden bg-secondary">
        <img
          src="https://images.unsplash.com/photo-1528360983277-13d401cdc186?w=1200&q=85"
          alt="Okinawa"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40" />
        <div className="absolute bottom-10 left-10 right-10 z-10">
          <p className="text-3xl font-extrabold text-white leading-tight mb-2">{tagline}</p>
          <p className="text-white/70 text-sm leading-relaxed">{subtagline}</p>
        </div>
      </div>

      {/* Right: form */}
      <div className="flex flex-col items-center justify-center w-full lg:w-[55%] px-6 py-10 bg-background">
        <div className="w-full max-w-sm">
          <Link to="/" className="flex flex-col items-center mb-6">
            <Logo className="h-10 w-10 rounded-xl mb-2" />
            <span className="font-bold text-base">Chic<span className="text-primary">Travel</span></span>
          </Link>
          {children}
        </div>
      </div>
    </div>
  )
}
